/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipTypeBase,
  MembershipTypeBaseOptional,
  MembershipTypeBaseMetaI,
  MembershipTypeBaseTrackedI,
} from "./membership-type-base";
import {
  MembershipTypeBaseTracked,
  MembershipTypeBaseMeta,
} from "./membership-type-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipTypeRef,
  MembershipTypeRefOptional,
  MembershipTypeRefMetaI,
  MembershipTypeRefTrackedI,
} from "./membership-type-ref";
import {
  MembershipTypeRefTracked,
  MembershipTypeRefMeta,
} from "./membership-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";

/**
 *
 * @export
 * @interface MembershipTypeFull
 */
export interface MembershipTypeFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionName?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDescriptionShort?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDescriptionLong?: string;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  availableOnline?: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof MembershipTypeFull
   */
  programId?: ProgramTypeRefOptional;
  /**
   * Duration value (likely days/months depending on business logic)
   * @type {number}
   * @memberof MembershipTypeFull
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  expirationType?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  oldDiscountType?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  regCodeRowId?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  alertOnClose?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  gcEligible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  canHaveGuestPrivs?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  gcRegCodeRowId?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  ratingsRestricted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  taxable?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  programPriority?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  renewalEligible?: boolean;
}

export interface MembershipTypeFull
  extends
    MembershipTypeFullOptional,
    Deletable,
    MembershipTypeBase,
    MembershipTypeRef {
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionName?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDescriptionShort?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDescriptionLong?: string;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  availableOnline?: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof MembershipTypeFull
   */
  programId?: ProgramTypeRef;
  /**
   * Duration value (likely days/months depending on business logic)
   * @type {number}
   * @memberof MembershipTypeFull
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  expirationType?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  oldDiscountType?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  regCodeRowId?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  alertOnClose?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  gcEligible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  canHaveGuestPrivs?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  gcRegCodeRowId?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  ratingsRestricted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  taxable?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  programPriority?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  renewalEligible?: boolean;
}

export interface MembershipTypeFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionName?: string;
  optionNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDisplayName?: string;
  optionDisplayNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDescriptionShort?: string;
  optionDescriptionShortIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  optionDescriptionLong?: string;
  optionDescriptionLongIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  availableOnline?: boolean;
  availableOnlineIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof MembershipTypeFull
   */
  programId?: ProgramTypeRefTrackedI;
  programIdIsSet: boolean;
  /**
   * Duration value (likely days/months depending on business logic)
   * @type {number}
   * @memberof MembershipTypeFull
   */
  duration?: number;
  durationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeFull
   */
  expirationType?: string;
  expirationTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  oldDiscountType?: number;
  oldDiscountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  regCodeRowId?: number;
  regCodeRowIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  alertOnClose?: boolean;
  alertOnCloseIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  gcEligible?: boolean;
  gcEligibleIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  canHaveGuestPrivs?: boolean;
  canHaveGuestPrivsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  gcRegCodeRowId?: number;
  gcRegCodeRowIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  ratingsRestricted?: boolean;
  ratingsRestrictedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  taxable?: boolean;
  taxableIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeFull
   */
  programPriority?: number;
  programPriorityIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeFull
   */
  renewalEligible?: boolean;
  renewalEligibleIsSet: boolean;
}

transformDatesMap.set(
  "MembershipTypeFull",
  function (model: MembershipTypeFull) {
    const transformDatesprogramId = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogramId && model.programId) {
      transformDatesprogramId(model.programId);
    }
  },
);

export type MembershipTypeFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  optionName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDisplayName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDescriptionShort: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDescriptionLong: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  availableOnline: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  programId: PropertyMeta<ProgramTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  duration: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  expirationType: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  oldDiscountType: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  regCodeRowId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  alertOnClose: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  gcEligible: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  canHaveGuestPrivs: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  gcRegCodeRowId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  ratingsRestricted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  taxable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  programPriority: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  renewalEligible: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var MembershipTypeFullMeta: MembershipTypeFullMetaI =
  {} as MembershipTypeFullMetaI;
MembershipTypeFullMeta = typeMeta("MembershipTypeFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  optionName: propertyMeta(
    "optionName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDisplayName: propertyMeta(
    "optionDisplayName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDescriptionShort: propertyMeta(
    "optionDescriptionShort",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDescriptionLong: propertyMeta(
    "optionDescriptionLong",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  availableOnline: propertyMeta(
    "availableOnline",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  programId: propertyMeta("programId", false, false, false, ProgramTypeRefMeta),
  duration: propertyMeta("duration", false, false, false, MetaTypesBase.number),
  expirationType: propertyMeta(
    "expirationType",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  oldDiscountType: propertyMeta(
    "oldDiscountType",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  regCodeRowId: propertyMeta(
    "regCodeRowId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  alertOnClose: propertyMeta(
    "alertOnClose",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  gcEligible: propertyMeta(
    "gcEligible",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  canHaveGuestPrivs: propertyMeta(
    "canHaveGuestPrivs",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  gcRegCodeRowId: propertyMeta(
    "gcRegCodeRowId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  ratingsRestricted: propertyMeta(
    "ratingsRestricted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  taxable: propertyMeta("taxable", false, false, false, MetaTypesBase.boolean),
  programPriority: propertyMeta(
    "programPriority",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  renewalEligible: propertyMeta(
    "renewalEligible",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = MembershipTypeFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([MembershipTypeRefMeta]);
  metaI.assignId.inheritedFrom = MembershipTypeRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([MembershipTypeBaseMeta]);
  metaI.assignId.inheritedFrom = MembershipTypeBaseMeta.assignId;
  metaI.price.inheritedFrom = MembershipTypeBaseMeta.price;
  metaI.displayOrder.inheritedFrom = MembershipTypeBaseMeta.displayOrder;
  metaI.active.inheritedFrom = MembershipTypeBaseMeta.active;
  metaI.optionName.inheritedFrom = MembershipTypeBaseMeta.optionName;
  metaI.optionDisplayName.inheritedFrom =
    MembershipTypeBaseMeta.optionDisplayName;
  metaI.optionDescriptionShort.inheritedFrom =
    MembershipTypeBaseMeta.optionDescriptionShort;
  metaI.optionDescriptionLong.inheritedFrom =
    MembershipTypeBaseMeta.optionDescriptionLong;
  metaI.availableOnline.inheritedFrom = MembershipTypeBaseMeta.availableOnline;
  metaI.programId.inheritedFrom = MembershipTypeBaseMeta.programId;
  metaI.duration.inheritedFrom = MembershipTypeBaseMeta.duration;
  metaI.expirationType.inheritedFrom = MembershipTypeBaseMeta.expirationType;
  metaI.oldDiscountType.inheritedFrom = MembershipTypeBaseMeta.oldDiscountType;
  metaI.regCodeRowId.inheritedFrom = MembershipTypeBaseMeta.regCodeRowId;
  metaI.alertOnClose.inheritedFrom = MembershipTypeBaseMeta.alertOnClose;
  metaI.gcEligible.inheritedFrom = MembershipTypeBaseMeta.gcEligible;
  metaI.canHaveGuestPrivs.inheritedFrom =
    MembershipTypeBaseMeta.canHaveGuestPrivs;
  metaI.gcRegCodeRowId.inheritedFrom = MembershipTypeBaseMeta.gcRegCodeRowId;
  metaI.ratingsRestricted.inheritedFrom =
    MembershipTypeBaseMeta.ratingsRestricted;
  metaI.taxable.inheritedFrom = MembershipTypeBaseMeta.taxable;
  metaI.programPriority.inheritedFrom = MembershipTypeBaseMeta.programPriority;
  metaI.renewalEligible.inheritedFrom = MembershipTypeBaseMeta.renewalEligible;
});

export class MembershipTypeFullTracked
  extends DeletableTracked
  implements MembershipTypeFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  optionName__I?: string = undefined;
  optionNameIsSet: boolean = false;
  set optionName(v: undefined | string) {
    if (v !== undefined) {
      this.optionName__I = v;
      this.optionNameIsSet = true;
    } else {
      this.optionName__I = v || undefined;
      this.optionNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionName() {
    return this.optionName__I;
  }
  optionDisplayName__I?: string = undefined;
  optionDisplayNameIsSet: boolean = false;
  set optionDisplayName(v: undefined | string) {
    if (v !== undefined) {
      this.optionDisplayName__I = v;
      this.optionDisplayNameIsSet = true;
    } else {
      this.optionDisplayName__I = v || undefined;
      this.optionDisplayNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDisplayName() {
    return this.optionDisplayName__I;
  }
  optionDescriptionShort__I?: string = undefined;
  optionDescriptionShortIsSet: boolean = false;
  set optionDescriptionShort(v: undefined | string) {
    if (v !== undefined) {
      this.optionDescriptionShort__I = v;
      this.optionDescriptionShortIsSet = true;
    } else {
      this.optionDescriptionShort__I = v || undefined;
      this.optionDescriptionShortIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDescriptionShort() {
    return this.optionDescriptionShort__I;
  }
  optionDescriptionLong__I?: string = undefined;
  optionDescriptionLongIsSet: boolean = false;
  set optionDescriptionLong(v: undefined | string) {
    if (v !== undefined) {
      this.optionDescriptionLong__I = v;
      this.optionDescriptionLongIsSet = true;
    } else {
      this.optionDescriptionLong__I = v || undefined;
      this.optionDescriptionLongIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDescriptionLong() {
    return this.optionDescriptionLong__I;
  }
  availableOnline__I?: boolean = undefined;
  availableOnlineIsSet: boolean = false;
  set availableOnline(v: undefined | boolean) {
    if (v !== undefined) {
      this.availableOnline__I = v;
      this.availableOnlineIsSet = true;
    } else {
      this.availableOnline__I = v || undefined;
      this.availableOnlineIsSet = false;
    }
    this.changeTracker = true;
  }
  get availableOnline() {
    return this.availableOnline__I;
  }
  programId__I?: ProgramTypeRefTracked = undefined;
  programIdIsSet: boolean = false;
  set programId(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.programId__I = v;
      this.programIdIsSet = true;
    } else {
      this.programId__I = v || undefined;
      this.programIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get programId() {
    return this.programId__I;
  }
  duration__I?: number = undefined;
  durationIsSet: boolean = false;
  set duration(v: undefined | number) {
    if (v !== undefined) {
      this.duration__I = v;
      this.durationIsSet = true;
    } else {
      this.duration__I = v || undefined;
      this.durationIsSet = false;
    }
    this.changeTracker = true;
  }
  get duration() {
    return this.duration__I;
  }
  expirationType__I?: string = undefined;
  expirationTypeIsSet: boolean = false;
  set expirationType(v: undefined | string) {
    if (v !== undefined) {
      this.expirationType__I = v;
      this.expirationTypeIsSet = true;
    } else {
      this.expirationType__I = v || undefined;
      this.expirationTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get expirationType() {
    return this.expirationType__I;
  }
  oldDiscountType__I?: number = undefined;
  oldDiscountTypeIsSet: boolean = false;
  set oldDiscountType(v: undefined | number) {
    if (v !== undefined) {
      this.oldDiscountType__I = v;
      this.oldDiscountTypeIsSet = true;
    } else {
      this.oldDiscountType__I = v || undefined;
      this.oldDiscountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get oldDiscountType() {
    return this.oldDiscountType__I;
  }
  regCodeRowId__I?: number = undefined;
  regCodeRowIdIsSet: boolean = false;
  set regCodeRowId(v: undefined | number) {
    if (v !== undefined) {
      this.regCodeRowId__I = v;
      this.regCodeRowIdIsSet = true;
    } else {
      this.regCodeRowId__I = v || undefined;
      this.regCodeRowIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get regCodeRowId() {
    return this.regCodeRowId__I;
  }
  alertOnClose__I?: boolean = undefined;
  alertOnCloseIsSet: boolean = false;
  set alertOnClose(v: undefined | boolean) {
    if (v !== undefined) {
      this.alertOnClose__I = v;
      this.alertOnCloseIsSet = true;
    } else {
      this.alertOnClose__I = v || undefined;
      this.alertOnCloseIsSet = false;
    }
    this.changeTracker = true;
  }
  get alertOnClose() {
    return this.alertOnClose__I;
  }
  gcEligible__I?: boolean = undefined;
  gcEligibleIsSet: boolean = false;
  set gcEligible(v: undefined | boolean) {
    if (v !== undefined) {
      this.gcEligible__I = v;
      this.gcEligibleIsSet = true;
    } else {
      this.gcEligible__I = v || undefined;
      this.gcEligibleIsSet = false;
    }
    this.changeTracker = true;
  }
  get gcEligible() {
    return this.gcEligible__I;
  }
  canHaveGuestPrivs__I?: boolean = undefined;
  canHaveGuestPrivsIsSet: boolean = false;
  set canHaveGuestPrivs(v: undefined | boolean) {
    if (v !== undefined) {
      this.canHaveGuestPrivs__I = v;
      this.canHaveGuestPrivsIsSet = true;
    } else {
      this.canHaveGuestPrivs__I = v || undefined;
      this.canHaveGuestPrivsIsSet = false;
    }
    this.changeTracker = true;
  }
  get canHaveGuestPrivs() {
    return this.canHaveGuestPrivs__I;
  }
  gcRegCodeRowId__I?: number = undefined;
  gcRegCodeRowIdIsSet: boolean = false;
  set gcRegCodeRowId(v: undefined | number) {
    if (v !== undefined) {
      this.gcRegCodeRowId__I = v;
      this.gcRegCodeRowIdIsSet = true;
    } else {
      this.gcRegCodeRowId__I = v || undefined;
      this.gcRegCodeRowIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get gcRegCodeRowId() {
    return this.gcRegCodeRowId__I;
  }
  ratingsRestricted__I?: boolean = undefined;
  ratingsRestrictedIsSet: boolean = false;
  set ratingsRestricted(v: undefined | boolean) {
    if (v !== undefined) {
      this.ratingsRestricted__I = v;
      this.ratingsRestrictedIsSet = true;
    } else {
      this.ratingsRestricted__I = v || undefined;
      this.ratingsRestrictedIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingsRestricted() {
    return this.ratingsRestricted__I;
  }
  taxable__I?: boolean = undefined;
  taxableIsSet: boolean = false;
  set taxable(v: undefined | boolean) {
    if (v !== undefined) {
      this.taxable__I = v;
      this.taxableIsSet = true;
    } else {
      this.taxable__I = v || undefined;
      this.taxableIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxable() {
    return this.taxable__I;
  }
  programPriority__I?: number = undefined;
  programPriorityIsSet: boolean = false;
  set programPriority(v: undefined | number) {
    if (v !== undefined) {
      this.programPriority__I = v;
      this.programPriorityIsSet = true;
    } else {
      this.programPriority__I = v || undefined;
      this.programPriorityIsSet = false;
    }
    this.changeTracker = true;
  }
  get programPriority() {
    return this.programPriority__I;
  }
  renewalEligible__I?: boolean = undefined;
  renewalEligibleIsSet: boolean = false;
  set renewalEligible(v: undefined | boolean) {
    if (v !== undefined) {
      this.renewalEligible__I = v;
      this.renewalEligibleIsSet = true;
    } else {
      this.renewalEligible__I = v || undefined;
      this.renewalEligibleIsSet = false;
    }
    this.changeTracker = true;
  }
  get renewalEligible() {
    return this.renewalEligible__I;
  }
  constructor(config?: MembershipTypeFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.programId?.setIds();
  }
  assignFrom(
    config: MembershipTypeFullOptional,
    options?: AssignOptions,
  ): MembershipTypeFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.optionName &&
      this.optionNameApplyFilter(optionsRequired.filter)
    ) {
      this.optionName = config.optionName;
      if (optionsRequired.unassign) this.optionNameIsSet = false;
      else this.optionNameIsSet = true;
    }
    if (
      config.optionDisplayName &&
      this.optionDisplayNameApplyFilter(optionsRequired.filter)
    ) {
      this.optionDisplayName = config.optionDisplayName;
      if (optionsRequired.unassign) this.optionDisplayNameIsSet = false;
      else this.optionDisplayNameIsSet = true;
    }
    if (
      config.optionDescriptionShort &&
      this.optionDescriptionShortApplyFilter(optionsRequired.filter)
    ) {
      this.optionDescriptionShort = config.optionDescriptionShort;
      if (optionsRequired.unassign) this.optionDescriptionShortIsSet = false;
      else this.optionDescriptionShortIsSet = true;
    }
    if (
      config.optionDescriptionLong &&
      this.optionDescriptionLongApplyFilter(optionsRequired.filter)
    ) {
      this.optionDescriptionLong = config.optionDescriptionLong;
      if (optionsRequired.unassign) this.optionDescriptionLongIsSet = false;
      else this.optionDescriptionLongIsSet = true;
    }
    if (
      config.availableOnline &&
      this.availableOnlineApplyFilter(optionsRequired.filter)
    ) {
      this.availableOnline = config.availableOnline;
      if (optionsRequired.unassign) this.availableOnlineIsSet = false;
      else this.availableOnlineIsSet = true;
    }
    if (config.programId && this.programIdApplyFilter(optionsRequired.filter)) {
      this.programId = new ProgramTypeRefTracked(config.programId, options);
      if (optionsRequired.unassign) this.programIdIsSet = false;
      else this.programIdIsSet = true;
    }
    if (config.duration && this.durationApplyFilter(optionsRequired.filter)) {
      this.duration = config.duration;
      if (optionsRequired.unassign) this.durationIsSet = false;
      else this.durationIsSet = true;
    }
    if (
      config.expirationType &&
      this.expirationTypeApplyFilter(optionsRequired.filter)
    ) {
      this.expirationType = config.expirationType;
      if (optionsRequired.unassign) this.expirationTypeIsSet = false;
      else this.expirationTypeIsSet = true;
    }
    if (
      config.oldDiscountType &&
      this.oldDiscountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.oldDiscountType = config.oldDiscountType;
      if (optionsRequired.unassign) this.oldDiscountTypeIsSet = false;
      else this.oldDiscountTypeIsSet = true;
    }
    if (
      config.regCodeRowId &&
      this.regCodeRowIdApplyFilter(optionsRequired.filter)
    ) {
      this.regCodeRowId = config.regCodeRowId;
      if (optionsRequired.unassign) this.regCodeRowIdIsSet = false;
      else this.regCodeRowIdIsSet = true;
    }
    if (
      config.alertOnClose &&
      this.alertOnCloseApplyFilter(optionsRequired.filter)
    ) {
      this.alertOnClose = config.alertOnClose;
      if (optionsRequired.unassign) this.alertOnCloseIsSet = false;
      else this.alertOnCloseIsSet = true;
    }
    if (
      config.gcEligible &&
      this.gcEligibleApplyFilter(optionsRequired.filter)
    ) {
      this.gcEligible = config.gcEligible;
      if (optionsRequired.unassign) this.gcEligibleIsSet = false;
      else this.gcEligibleIsSet = true;
    }
    if (
      config.canHaveGuestPrivs &&
      this.canHaveGuestPrivsApplyFilter(optionsRequired.filter)
    ) {
      this.canHaveGuestPrivs = config.canHaveGuestPrivs;
      if (optionsRequired.unassign) this.canHaveGuestPrivsIsSet = false;
      else this.canHaveGuestPrivsIsSet = true;
    }
    if (
      config.gcRegCodeRowId &&
      this.gcRegCodeRowIdApplyFilter(optionsRequired.filter)
    ) {
      this.gcRegCodeRowId = config.gcRegCodeRowId;
      if (optionsRequired.unassign) this.gcRegCodeRowIdIsSet = false;
      else this.gcRegCodeRowIdIsSet = true;
    }
    if (
      config.ratingsRestricted &&
      this.ratingsRestrictedApplyFilter(optionsRequired.filter)
    ) {
      this.ratingsRestricted = config.ratingsRestricted;
      if (optionsRequired.unassign) this.ratingsRestrictedIsSet = false;
      else this.ratingsRestrictedIsSet = true;
    }
    if (config.taxable && this.taxableApplyFilter(optionsRequired.filter)) {
      this.taxable = config.taxable;
      if (optionsRequired.unassign) this.taxableIsSet = false;
      else this.taxableIsSet = true;
    }
    if (
      config.programPriority &&
      this.programPriorityApplyFilter(optionsRequired.filter)
    ) {
      this.programPriority = config.programPriority;
      if (optionsRequired.unassign) this.programPriorityIsSet = false;
      else this.programPriorityIsSet = true;
    }
    if (
      config.renewalEligible &&
      this.renewalEligibleApplyFilter(optionsRequired.filter)
    ) {
      this.renewalEligible = config.renewalEligible;
      if (optionsRequired.unassign) this.renewalEligibleIsSet = false;
      else this.renewalEligibleIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): MembershipTypeFullTrackedI {
    const cloned = {} as MembershipTypeFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.optionNameIsSetDeep() &&
      this.optionNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionNameIsSet = true;
      cloned.optionName = this.optionName;
    } else {
      //cloned.optionNameIsSet = false
    }
    if (
      this.optionDisplayNameIsSetDeep() &&
      this.optionDisplayNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDisplayNameIsSet = true;
      cloned.optionDisplayName = this.optionDisplayName;
    } else {
      //cloned.optionDisplayNameIsSet = false
    }
    if (
      this.optionDescriptionShortIsSetDeep() &&
      this.optionDescriptionShortApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDescriptionShortIsSet = true;
      cloned.optionDescriptionShort = this.optionDescriptionShort;
    } else {
      //cloned.optionDescriptionShortIsSet = false
    }
    if (
      this.optionDescriptionLongIsSetDeep() &&
      this.optionDescriptionLongApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDescriptionLongIsSet = true;
      cloned.optionDescriptionLong = this.optionDescriptionLong;
    } else {
      //cloned.optionDescriptionLongIsSet = false
    }
    if (
      this.availableOnlineIsSetDeep() &&
      this.availableOnlineApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availableOnlineIsSet = true;
      cloned.availableOnline = this.availableOnline;
    } else {
      //cloned.availableOnlineIsSet = false
    }
    if (
      this.programIdIsSetDeep() &&
      this.programIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIdIsSet = true;
      cloned.programId = this.programId?.removeUnset(filter);
    } else {
      //cloned.programIdIsSet = false
    }
    if (
      this.durationIsSetDeep() &&
      this.durationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.durationIsSet = true;
      cloned.duration = this.duration;
    } else {
      //cloned.durationIsSet = false
    }
    if (
      this.expirationTypeIsSetDeep() &&
      this.expirationTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expirationTypeIsSet = true;
      cloned.expirationType = this.expirationType;
    } else {
      //cloned.expirationTypeIsSet = false
    }
    if (
      this.oldDiscountTypeIsSetDeep() &&
      this.oldDiscountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.oldDiscountTypeIsSet = true;
      cloned.oldDiscountType = this.oldDiscountType;
    } else {
      //cloned.oldDiscountTypeIsSet = false
    }
    if (
      this.regCodeRowIdIsSetDeep() &&
      this.regCodeRowIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.regCodeRowIdIsSet = true;
      cloned.regCodeRowId = this.regCodeRowId;
    } else {
      //cloned.regCodeRowIdIsSet = false
    }
    if (
      this.alertOnCloseIsSetDeep() &&
      this.alertOnCloseApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.alertOnCloseIsSet = true;
      cloned.alertOnClose = this.alertOnClose;
    } else {
      //cloned.alertOnCloseIsSet = false
    }
    if (
      this.gcEligibleIsSetDeep() &&
      this.gcEligibleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.gcEligibleIsSet = true;
      cloned.gcEligible = this.gcEligible;
    } else {
      //cloned.gcEligibleIsSet = false
    }
    if (
      this.canHaveGuestPrivsIsSetDeep() &&
      this.canHaveGuestPrivsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.canHaveGuestPrivsIsSet = true;
      cloned.canHaveGuestPrivs = this.canHaveGuestPrivs;
    } else {
      //cloned.canHaveGuestPrivsIsSet = false
    }
    if (
      this.gcRegCodeRowIdIsSetDeep() &&
      this.gcRegCodeRowIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.gcRegCodeRowIdIsSet = true;
      cloned.gcRegCodeRowId = this.gcRegCodeRowId;
    } else {
      //cloned.gcRegCodeRowIdIsSet = false
    }
    if (
      this.ratingsRestrictedIsSetDeep() &&
      this.ratingsRestrictedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingsRestrictedIsSet = true;
      cloned.ratingsRestricted = this.ratingsRestricted;
    } else {
      //cloned.ratingsRestrictedIsSet = false
    }
    if (
      this.taxableIsSetDeep() &&
      this.taxableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxableIsSet = true;
      cloned.taxable = this.taxable;
    } else {
      //cloned.taxableIsSet = false
    }
    if (
      this.programPriorityIsSetDeep() &&
      this.programPriorityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programPriorityIsSet = true;
      cloned.programPriority = this.programPriority;
    } else {
      //cloned.programPriorityIsSet = false
    }
    if (
      this.renewalEligibleIsSetDeep() &&
      this.renewalEligibleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.renewalEligibleIsSet = true;
      cloned.renewalEligible = this.renewalEligible;
    } else {
      //cloned.renewalEligibleIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): MembershipTypeFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.optionNameApplyFilter(filter)) this.optionNameIsSet = false;

    if (!this.optionDisplayNameApplyFilter(filter))
      this.optionDisplayNameIsSet = false;

    if (!this.optionDescriptionShortApplyFilter(filter))
      this.optionDescriptionShortIsSet = false;

    if (!this.optionDescriptionLongApplyFilter(filter))
      this.optionDescriptionLongIsSet = false;

    if (!this.availableOnlineApplyFilter(filter))
      this.availableOnlineIsSet = false;

    if (!this.programIdApplyFilter(filter)) this.programIdIsSet = false;
    this.programId?.unassignAll(filter);

    if (!this.durationApplyFilter(filter)) this.durationIsSet = false;

    if (!this.expirationTypeApplyFilter(filter))
      this.expirationTypeIsSet = false;

    if (!this.oldDiscountTypeApplyFilter(filter))
      this.oldDiscountTypeIsSet = false;

    if (!this.regCodeRowIdApplyFilter(filter)) this.regCodeRowIdIsSet = false;

    if (!this.alertOnCloseApplyFilter(filter)) this.alertOnCloseIsSet = false;

    if (!this.gcEligibleApplyFilter(filter)) this.gcEligibleIsSet = false;

    if (!this.canHaveGuestPrivsApplyFilter(filter))
      this.canHaveGuestPrivsIsSet = false;

    if (!this.gcRegCodeRowIdApplyFilter(filter))
      this.gcRegCodeRowIdIsSet = false;

    if (!this.ratingsRestrictedApplyFilter(filter))
      this.ratingsRestrictedIsSet = false;

    if (!this.taxableApplyFilter(filter)) this.taxableIsSet = false;

    if (!this.programPriorityApplyFilter(filter))
      this.programPriorityIsSet = false;

    if (!this.renewalEligibleApplyFilter(filter))
      this.renewalEligibleIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.isDeleted,
      MembershipTypeFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.isNew,
      MembershipTypeFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.assignId,
      MembershipTypeFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.price,
      MembershipTypeFullMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.displayOrder,
      MembershipTypeFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.active,
      MembershipTypeFullMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  optionNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.optionName,
      MembershipTypeFullMeta,
      this.optionName,
      this,
    );
  }
  optionNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optionNameIsSet && this.optionNameApplyFilter(filter)) return true;

    return false;
  }
  optionDisplayNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.optionDisplayName,
      MembershipTypeFullMeta,
      this.optionDisplayName,
      this,
    );
  }
  optionDisplayNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDisplayNameIsSet &&
      this.optionDisplayNameApplyFilter(filter)
    )
      return true;

    return false;
  }
  optionDescriptionShortApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.optionDescriptionShort,
      MembershipTypeFullMeta,
      this.optionDescriptionShort,
      this,
    );
  }
  optionDescriptionShortIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDescriptionShortIsSet &&
      this.optionDescriptionShortApplyFilter(filter)
    )
      return true;

    return false;
  }
  optionDescriptionLongApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.optionDescriptionLong,
      MembershipTypeFullMeta,
      this.optionDescriptionLong,
      this,
    );
  }
  optionDescriptionLongIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDescriptionLongIsSet &&
      this.optionDescriptionLongApplyFilter(filter)
    )
      return true;

    return false;
  }
  availableOnlineApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.availableOnline,
      MembershipTypeFullMeta,
      this.availableOnline,
      this,
    );
  }
  availableOnlineIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.availableOnlineIsSet && this.availableOnlineApplyFilter(filter))
      return true;

    return false;
  }
  programIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.programId,
      MembershipTypeFullMeta,
      this.programId,
      this,
    );
  }
  programIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIdIsSet && this.programIdApplyFilter(filter)) return true;
    return this.programId?.anySet(filter) == true;

    return false;
  }
  durationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.duration,
      MembershipTypeFullMeta,
      this.duration,
      this,
    );
  }
  durationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.durationIsSet && this.durationApplyFilter(filter)) return true;

    return false;
  }
  expirationTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.expirationType,
      MembershipTypeFullMeta,
      this.expirationType,
      this,
    );
  }
  expirationTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expirationTypeIsSet && this.expirationTypeApplyFilter(filter))
      return true;

    return false;
  }
  oldDiscountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.oldDiscountType,
      MembershipTypeFullMeta,
      this.oldDiscountType,
      this,
    );
  }
  oldDiscountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.oldDiscountTypeIsSet && this.oldDiscountTypeApplyFilter(filter))
      return true;

    return false;
  }
  regCodeRowIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.regCodeRowId,
      MembershipTypeFullMeta,
      this.regCodeRowId,
      this,
    );
  }
  regCodeRowIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.regCodeRowIdIsSet && this.regCodeRowIdApplyFilter(filter))
      return true;

    return false;
  }
  alertOnCloseApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.alertOnClose,
      MembershipTypeFullMeta,
      this.alertOnClose,
      this,
    );
  }
  alertOnCloseIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.alertOnCloseIsSet && this.alertOnCloseApplyFilter(filter))
      return true;

    return false;
  }
  gcEligibleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.gcEligible,
      MembershipTypeFullMeta,
      this.gcEligible,
      this,
    );
  }
  gcEligibleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.gcEligibleIsSet && this.gcEligibleApplyFilter(filter)) return true;

    return false;
  }
  canHaveGuestPrivsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.canHaveGuestPrivs,
      MembershipTypeFullMeta,
      this.canHaveGuestPrivs,
      this,
    );
  }
  canHaveGuestPrivsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.canHaveGuestPrivsIsSet &&
      this.canHaveGuestPrivsApplyFilter(filter)
    )
      return true;

    return false;
  }
  gcRegCodeRowIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.gcRegCodeRowId,
      MembershipTypeFullMeta,
      this.gcRegCodeRowId,
      this,
    );
  }
  gcRegCodeRowIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.gcRegCodeRowIdIsSet && this.gcRegCodeRowIdApplyFilter(filter))
      return true;

    return false;
  }
  ratingsRestrictedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.ratingsRestricted,
      MembershipTypeFullMeta,
      this.ratingsRestricted,
      this,
    );
  }
  ratingsRestrictedIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.ratingsRestrictedIsSet &&
      this.ratingsRestrictedApplyFilter(filter)
    )
      return true;

    return false;
  }
  taxableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.taxable,
      MembershipTypeFullMeta,
      this.taxable,
      this,
    );
  }
  taxableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxableIsSet && this.taxableApplyFilter(filter)) return true;

    return false;
  }
  programPriorityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.programPriority,
      MembershipTypeFullMeta,
      this.programPriority,
      this,
    );
  }
  programPriorityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programPriorityIsSet && this.programPriorityApplyFilter(filter))
      return true;

    return false;
  }
  renewalEligibleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeFullMeta.renewalEligible,
      MembershipTypeFullMeta,
      this.renewalEligible,
      this,
    );
  }
  renewalEligibleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.renewalEligibleIsSet && this.renewalEligibleApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.optionNameIsSetDeep(filter)) return true;
    if (this.optionDisplayNameIsSetDeep(filter)) return true;
    if (this.optionDescriptionShortIsSetDeep(filter)) return true;
    if (this.optionDescriptionLongIsSetDeep(filter)) return true;
    if (this.availableOnlineIsSetDeep(filter)) return true;
    if (this.programIdIsSetDeep(filter)) return true;
    if (this.durationIsSetDeep(filter)) return true;
    if (this.expirationTypeIsSetDeep(filter)) return true;
    if (this.oldDiscountTypeIsSetDeep(filter)) return true;
    if (this.regCodeRowIdIsSetDeep(filter)) return true;
    if (this.alertOnCloseIsSetDeep(filter)) return true;
    if (this.gcEligibleIsSetDeep(filter)) return true;
    if (this.canHaveGuestPrivsIsSetDeep(filter)) return true;
    if (this.gcRegCodeRowIdIsSetDeep(filter)) return true;
    if (this.ratingsRestrictedIsSetDeep(filter)) return true;
    if (this.taxableIsSetDeep(filter)) return true;
    if (this.programPriorityIsSetDeep(filter)) return true;
    if (this.renewalEligibleIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
